<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData">
      <template v-slot:detail="update">
        <!--属性列表-->
        <TYPE :update="update"></TYPE>
      </template>
    </UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '../components/page/table.vue'
  import FORM from '../components/page/form.vue'
  import UPDATE from '../components/page/update.vue'
  import TYPE from '@/views/mis/activeTemplate/type.vue'
  import Url from '@/views/mis/util/url'
  import Qs from 'qs'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE,
      TYPE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
            row.detail = JSON.parse(row.detail);
            this.$refs.childUpdate.open(row);
        }else if(clickName == "delete"){
            this.dataChanage(Url.active.type.del,{id:row.id},res => {
                this.$refs.childTable.defaultGetData(this.queryData);
                if (res.code == 0){
                    this.$refs.childUpdate.close();
                    this.$message.success("suc");
                }else{
                    this.$message.error(res.message);
                }
            })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('mis.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if(window.$t('mis.bt.add') == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        model.detail = JSON.stringify(model.detail);
        this.dataChanage(model.id?Url.active.type.edit:Url.active.type.save,model,res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
                this.$refs.childUpdate.close();
                this.$message.success("suc");
            }else{
                this.$message.error(res.message);
            }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
            if(suc && (typeof suc == 'function')) suc(res);
        }).catch(res => {
            if(fail && (typeof fail == 'function')) fail(res);
        })
      }
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
              { title: 'id', field: 'id', hidden:true},
              { title: window.$t('mis.activeTemplate.type'), field: 'type',required:true},
              { title: window.$t('mis.activeTemplate.url'), field: 'url',textType:"textarea",required:true},
              { title: window.$t('mis.activeTemplate.detail'), field: 'detail',type:10,slot:'detail',data:[{}],required:true},
         ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t('mis.activeTemplate.type'), field: 'type'},
              {click: window.$t('mis.bt.search')},
              {click: window.$t('mis.bt.add')},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.active.type.query, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('mis.activeTemplate.type'), field: 'type'},
              { title: window.$t('mis.activeTemplate.detail'), field: 'detail'},
              { title: window.$t('mis.activeTemplate.url'), field: 'url'},
              {title:window.$t('mis.bt.operation'),btnClick:[{name:window.$t('mis.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit"},{name:window.$t('mis.bt.delete'),click:"delete",type:"primary",icon: "el-icon-delete"}]},
          ]
        }
      }
    }
  }
</script>
